
import { usePageTitle } from '../../hooks/usePageTitle';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';
import AboutHeroSection from './components/AboutHeroSection';
import VisionMissionSection from './components/VisionMissionSection';
import PositioningSection from './components/PositioningSection';
import MilestonesSection from './components/MilestonesSection';
import AboutCTASection from './components/AboutCTASection';

export default function About() {
  usePageTitle('page_title_about');

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "mainEntity": {
      "@type": "Organization",
      "name": "Koluno",
      "url": import.meta.env.VITE_SITE_URL || "https://koluno.com",
      "description": "Koluno是专业的达人营销平台，致力于为品牌提供全球化的整合营销解决方案，连接优质创作者与品牌方。",
      "foundingDate": "2020",
      "founder": {
        "@type": "Person",
        "name": "Koluno Team"
      },
      "mission": "帮助品牌通过达人营销快速进入全球市场，提升品牌影响力和销量。",
      "vision": "成为全球领先的达人营销平台，连接世界各地的优质创作者与品牌。"
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="关于我们 - Koluno达人营销平台"
        description="了解Koluno的发展历程、企业愿景和使命。我们致力于为品牌提供全球化的达人营销解决方案，连接优质创作者与品牌方。"
        keywords="关于Koluno,企业介绍,达人营销平台,公司历程,企业愿景,团队介绍"
        ogTitle="关于我们 - Koluno达人营销平台"
        ogDescription="了解Koluno的发展历程、企业愿景和使命。我们致力于为品牌提供全球化的达人营销解决方案，连接优质创作者与品牌方。"
        ogUrl={`${import.meta.env.VITE_SITE_URL || "https://koluno.com"}/about`}
        twitterTitle="关于我们 - Koluno达人营销平台"
        twitterDescription="了解Koluno的发展历程、企业愿景和使命。我们致力于为品牌提供全球化的达人营销解决方案，连接优质创作者与品牌方。"
        structuredData={structuredData}
      />
      
      <Header />
      
      <main>
        <AboutHeroSection />
        <VisionMissionSection />
        <PositioningSection />
        <MilestonesSection />
        <AboutCTASection />
      </main>

      <Footer />
    </div>
  );
}
